import { render, staticRenderFns } from "./iconGestion-white.vue?vue&type=template&id=df127976&scoped=true&"
import script from "./iconGestion-white.vue?vue&type=script&lang=js&"
export * from "./iconGestion-white.vue?vue&type=script&lang=js&"
import style0 from "./iconGestion-white.vue?vue&type=style&index=0&id=df127976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df127976",
  null
  
)

export default component.exports